

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "../styles/Service.css";
import api from '../apiService/api';

// const BASE_URL = "https://api.kasbah-magic.com/conciergeLastVersion/";
const API_URL = api.API_URL + "read_service";
const BASE_URL = api.BASE_URL;

const Services = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const [services, setServices] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [servicesPerPage, setServicesPerPage] = useState(3);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${BASE_URL}index.php?action=read_service`);
        const data = await response.json();
        console.log("data",data) 

        if (data.success && Array.isArray(data.services)) {
          console.log("Services",data.services) 
          setServices(
            data.services.map(service => ({
              title: service.name,
              description: service.description,
              image: `${service.image_url}`,
              alt: service.name
            }))
          );

        } else {
          setError("Invalid data format");
        }
      } catch (error) {
        setError("");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();

  }, []);
 
 
  
  


  useEffect(() => {
    const updateServicesPerPage = () => {
      if (window.innerWidth <= 768) {
        setServicesPerPage(1);
      } else if (window.innerWidth <= 1024) {
        setServicesPerPage(2);
      } else {
        setServicesPerPage(3);
      }
    };

    updateServicesPerPage();
    window.addEventListener("resize", updateServicesPerPage);
    return () => window.removeEventListener("resize", updateServicesPerPage);
  }, []);

  const scrollLeft = () => {
    setCurrentIndex(prevIndex => (prevIndex === 0 ? services.length - servicesPerPage : prevIndex - 1));
  };

  const scrollRight = () => {
    setCurrentIndex(prevIndex => (prevIndex >= services.length - servicesPerPage ? 0 : prevIndex + 1));
  };


  

  if (loading) return <p>Loading services...</p>;
  if (error) return <p>{error}</p>;

  

  return (
    <div id="service-section" className="services-container" key={services.length}>
      <div className="services-content">
        <div className="Seheader-container">
          <h1 className="services-title">{t('ourServicesTitle')}</h1>
          <div className="Senavigation-buttons">
            <button className="Senav-btn" onClick={isArabic ? scrollRight : scrollLeft}>{isArabic ? "→" : "←"}</button>
            <button className="Senav-btn" onClick={isArabic ? scrollLeft : scrollRight}>{isArabic ? "←" : "→"}</button>
          </div>
        </div>

        <div className="services-grid">
          {services.slice(currentIndex, currentIndex + servicesPerPage).map((service, index) => (
            <div key={index} className="service-card">
              <div className="Seimage-container">
                <img src={service.image} alt={service.alt} className="service-image" />
                <div className="Seimage-overlay" />
              </div>
              <div className="service-info">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <button className="learn-more-btn" onClick={() => setSelectedService(service)}>
                  <span className="nav">{isArabic ? "←" : "→"}</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedService && (
        <div className="modal-overlay" onClick={() => setSelectedService(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedService(null)}>×</button>
            <img src={selectedService.image} alt={selectedService.alt} className="modal-image" />
            <h2 className="modal-title">{selectedService.title}</h2>
            <p className="modal-description">{selectedService.description}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;
